<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./About.translations.json";
	import thumbnail from "../assets/images/about/Spolecna.jpg";
	import aboutThumbnail from "../assets/images/about/Spolecna.jpg?webp&h=1080&imagetools";
	import StaticPicture from "../../../shared/components/Picture/StaticPicture.svelte";
	import about1 from "../assets/images/about/madalbal.jpg?webp&h=320&imagetools";
	import about2 from "../assets/images/about/hyndai.jpg?webp&h=320&imagetools";
	import about3 from "../assets/images/about/malfiny.jpg?webp&h=320&imagetools";
	import HomepageServices from "../components/HomepageServices.svelte";
	import type { AboutProps } from "./AboutProps.js";
	import { Department } from "../../../../core/schema/Department.js";
	import ContactCard from "../../../shared/components/Contact/ContactCard.svelte";
	import { setContext } from "svelte";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";

	type $$Props = AboutProps;

	const { contacts } = $$restProps as $$Props;

	const translate = getTranslate(translations);

	setContext(thumbnailImageContextKey, thumbnail);
</script>

<Layout>
	<section class="container">
		<div class="flex aspect-[8/5] items-center overflow-hidden rounded-lg md:aspect-auto md:h-[26.25rem]">
			<StaticPicture
				image={aboutThumbnail}
				alt={translate("h1")}
				width={1424}
				height={420}
				loading="eager"
				class="h-full w-full"
				imgClass="h-full w-full object-cover lg:object-[center_-8rem] xl:object-[center_-16rem]"
			/>
		</div>
	</section>
	<div class="container flex flex-col md:items-center">
		<div class="lg:w-[50rem]">
			<section>
				<h1 class="lg:text-3xl">{translate("h1")}</h1>
				<p class="text-2md font-spaceGrotesk mb-7 leading-snug">{translate("p1")}</p>
				<p>{translate("p2")}</p>
				<p>{translate("p3")}</p>
			</section>
		</div>
	</div>
	<section class="container">
		<div class="col-span-3 grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3">
			{#each contacts as contact}
				<ContactCard extended={true} {contact} />
			{/each}
		</div>
	</section>
	<!-- TODO management (PK+BT) & Mrs. Olson cards -->
	<section>
		<div class="container flex flex-col md:items-center">
			<div class="lg:w-[50rem]">
				<h2>{translate("h2-1")}</h2>
				<p>{translate("p5")}</p>
				<p>{translate("p6")}</p>
				<p>{translate("p7")}</p>
			</div>
		</div>
	</section>

	<div class="mt-8 flex justify-center gap-2">
		<StaticPicture
			image={about1}
			alt="MadalBal"
			width={470}
			height={320}
			loading="eager"
			imgClass="w-[29.375rem] h-[20rem] object-cover rounded-lg"
		/>
		<StaticPicture
			image={about2}
			alt="Hyundai"
			width={470}
			height={320}
			loading="eager"
			imgClass="w-[29.375rem] h-[20rem] object-cover rounded-lg"
		/>
		<StaticPicture
			image={about3}
			alt="Malfiny"
			width={470}
			height={320}
			loading="eager"
			imgClass="w-[29.375rem] h-[20rem] object-cover rounded-lg"
		/>
	</div>
	<section class="container flex flex-col md:items-center">
		<div class="lg:w-[50rem]">
			<h2>{translate("h2-2")}</h2>
			<p>{translate("p8")}</p>
			<p>{translate("p9")}</p>
		</div>
	</section>
	<section class="container">
		<HomepageServices />
	</section>
</Layout>
